module.exports = __webpack_public_path__ + "img/07_mhb.263f0aed.jpg";